"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentTransitionList = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var uniqid_1 = tslib_1.__importDefault(require("uniqid"));
exports.ComponentTransitionList = function (props) {
    var children = props.children;
    var _a = react_1.useState(0), counter = _a[0], setCounter = _a[1];
    var keysMapper = react_1.useRef({});
    var childrenMapper = react_1.useRef({});
    var keys = react_1.useRef([]);
    var exitCount = react_1.useRef(0);
    var mounted = react_1.useRef(false);
    react_1.useEffect(function () {
        mounted.current = true;
    }, []);
    if (children) {
        var updatedState = updateAndSortChildren(keysMapper.current, childrenMapper.current, keys.current, children);
        keysMapper.current = updatedState.keysMapperUpdated;
        childrenMapper.current = updatedState.childrenMapperUpdated;
        keys.current = updatedState.internalKeysList;
        exitCount.current = updatedState.exitCount;
    }
    var onExitFinished = function (internalKey, onExitFinishedCallback) {
        var propsCallback = function () {
            onExitFinishedCallback && onExitFinishedCallback();
        };
        if (keysMapper.current[internalKey] !== null) {
            propsCallback();
            return;
        }
        exitCount.current--;
        delete keysMapper.current[internalKey];
        delete childrenMapper.current[internalKey];
        keys.current = keys.current.filter(function (key) { return key !== internalKey; });
        if (exitCount.current === 0) {
            setCounter(function () { return counter + 1; });
        }
        propsCallback();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, keys.current.map(function (internalKey) {
        var _a = childrenMapper.current[internalKey], props = _a.props, type = _a.type, children = _a.children;
        return react_1.default.createElement(type, tslib_1.__assign(tslib_1.__assign({}, props), { key: internalKey, animateOnMount: mounted.current || (props === null || props === void 0 ? void 0 : props.animateOnMount), onExitFinished: onExitFinished.bind(null, internalKey, props === null || props === void 0 ? void 0 : props.onExitFinished) }), children);
    })));
};
var invertMapper = function (keysMapper) {
    var inverted = {};
    for (var _i = 0, _a = Object.keys(keysMapper); _i < _a.length; _i++) {
        var key = _a[_i];
        if (keysMapper[key] !== null && keysMapper[key] !== undefined) {
            inverted[keysMapper[key]] = key;
        }
    }
    return inverted;
};
var updateAndSortChildren = function (keysMapper, childrenMapper, internalKeys, children) {
    var inverted = invertMapper(keysMapper);
    var keysMapperUpdated = tslib_1.__assign({}, keysMapper);
    var childrenMapperUpdated = tslib_1.__assign({}, childrenMapper);
    var internalKeysList = [];
    var childrenKeysAssert = [];
    for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
        var child = children_1[_i];
        var childKey = child === null || child === void 0 ? void 0 : child.key;
        var childInternalKey = inverted[childKey];
        if (childrenKeysAssert.indexOf(childKey) > -1) {
            logError("Detected duplicated key `" + childKey + "` in two children. Children keys should be unique.");
            continue;
        }
        if (childKey !== undefined && childKey !== null && childInternalKey === undefined) {
            var newKey = uniqid_1.default();
            internalKeysList.push(newKey);
            keysMapperUpdated[newKey] = childKey;
            childrenMapperUpdated[newKey] = getChildrenMapped(child);
            childrenKeysAssert.push(childKey);
        }
        else if (childInternalKey) {
            internalKeysList.push(childInternalKey);
            childrenMapperUpdated[childInternalKey] = getChildrenMapped(child);
            childrenKeysAssert.push(childKey);
        }
    }
    var exitCount = 0;
    var _loop_1 = function (i) {
        var exists = children.filter(function (child) { return child.key === keysMapper[internalKeys[i]]; }).length > 0;
        if (!exists) {
            internalKeysList = tslib_1.__spreadArrays(internalKeysList.slice(0, i), [internalKeys[i]], internalKeysList.slice(i));
            keysMapperUpdated[internalKeys[i]] = null;
            childrenMapperUpdated[internalKeys[i]].children = null;
            exitCount++;
        }
    };
    for (var i = 0; i < internalKeys.length; i++) {
        _loop_1(i);
    }
    return {
        keysMapperUpdated: keysMapperUpdated,
        childrenMapperUpdated: childrenMapperUpdated,
        internalKeysList: internalKeysList,
        exitCount: exitCount,
    };
};
var getChildrenMapped = function (child) {
    var _a = child.props, children = _a.children, props = tslib_1.__rest(_a, ["children"]);
    return {
        children: children,
        type: child === null || child === void 0 ? void 0 : child.type,
        props: props,
    };
};
var logError = function (message) {
    if (process.env.NODE_ENV === "development") {
        console.error(message);
    }
};
exports.ComponentTransitionList.displayName = "ComponentTransitionList";
